import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import Home from './pages/Home';
import Category from './pages/Category';
import Coloring from './pages/Coloring';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AppLoader from './components/AppLoader';
import GlobalStyle from './styles/GlobalStyle';
import Settings from './components/Settings';
import DialogflowWidget from './components/DialogflowWidget';
import { trackEvent } from './utils/analytics';
import { useRouteTracking } from './hooks/useRouteTracking';

// Create a component to handle route tracking inside the Router
const AppWithRouteTracking: React.FC = () => {
  // Use route tracking hook to automatically track all page views
  useRouteTracking();
  
  return (
    <AppLoader>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:categoryId" element={<Category />} />
        <Route path="/coloring/:categoryId/:imageId" element={<Coloring />} />
        <Route path="/settings" element={<Settings onClose={(()=>{})}/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </AppLoader>
  );
};

const App: React.FC = () => {
  useEffect(() => {
    // Initialize Firebase Analytics when app starts
    trackEvent('app_initialized', {
      app_version: '0.1.0',
      platform: 'web',
      user_agent: navigator.userAgent,
      screen_resolution: `${window.screen.width}x${window.screen.height}`,
      viewport_size: `${window.innerWidth}x${window.innerHeight}`,
      timestamp: new Date().toISOString()
    });
  }, []);

  return (
    <Provider store={store}>
      <GlobalStyle />
      <Router>
        <DialogflowWidget />
        <AppWithRouteTracking />
      </Router>
    </Provider>
  );
};

export default App; 